import React from 'react'

import parser, { processNodes } from 'react-html-parser'

import { Link as MuiLink } from '@material-ui/core'

import Link from '~/components/shared/Link'

type Props = {
  data: string
  options?: any
}

const ReactHtmlParser = ({ data, options = {} }: Props) => {
  const transform = (node, index) => {
    if (options?.transform) {
      const transformed = options.transform(node, index, transform)

      if (transformed) return transformed
    }

    if (node.type === 'tag' && node.name === 'img') {
      // TODO: fallback with process.env.__NEXT_IMAGE_OPTS.domains
      return (
        <img
          {...node.attribs}
          src={node.attribs.src}
          alt={node.attribs.alt}
          title={node.attribs.title}
          loading="lazy"
          style={{ maxWidth: '100%' }}
        />
      )
    }

    if (node.type === 'tag' && node.name === 'a') {
      if (node.attribs?.href && node.attribs.href[0] === '/') {
        return (
          <Link href={node.attribs.href}>
            {processNodes(node.children, transform)}
          </Link>
        )
      }
      return (
        <MuiLink
          component="a"
          href={node.attribs.href}
          target="_blank"
          rel="noreferrer"
          className="dont-break-out"
        >
          {processNodes(node.children, transform)}
        </MuiLink>
      )
    }
  }

  return <>{parser(data, { ...options, decodeEntities: true, transform })}</>
}

export default ReactHtmlParser
